import { Schema } from '../../../utils/form';
import { FormattedMessage } from 'react-intl';

export default Schema.object({
  area: Schema.string().label(''),
  areasSubordinadas: Schema.string().label(''),
  nome: Schema.string().label(<FormattedMessage id="nome" />),
  responsavel: Schema.string().label(''),
  idIntegracao: Schema.string().label(<FormattedMessage id="idIntegracao" />),
  processos: Schema.array().label(''),
  incluirSubprocessos: Schema.boolean().label(''),
  filtroMatrizRisco: Schema.string().label(''),
});
